import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ComponentType } from 'react';
import { SvgIconProps } from '@mui/material';
import * as Device from 'react-device-detect';

interface HeaderProps {
  handleCloseDialog: () => void;
  Icon: ComponentType<SvgIconProps>;
  title: string;
}

function Header(props: Readonly<HeaderProps>) {
  const theme = useTheme();
  const { handleCloseDialog, Icon, title } = props;

  return (
    <AppBar position={Device.isMobileOnly ? 'fixed' : 'sticky'} elevation={0}>
      <Toolbar sx={{ width: '100%' }}>
        <Stack direction="row" spacing={1} alignItems="center" width="100%">
          {<Icon fontSize="large" />}
          <Typography variant="h6" fontWeight="bold" width="100%">
            {title}
          </Typography>
          <IconButton onClick={handleCloseDialog}>
            <theme.icons.close color="inherit" />
          </IconButton>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
